angular.module('pipActions', ['ngMaterial', 'pipNav.Templates', 'ui.router']);

import './ActionsService';
import './PrimaryActions';
import './SecondaryActions';

export * from './IActionsService';